import React from "react";
import * as S from "./index.styles";
import { StateSelectFieldProps } from "./LocationFields.types";

const StateSelectField: React.FC<StateSelectFieldProps> = ({
  value, options, onChange, label, required, border
}) => (
  <S.FieldContainer>
    <S.FieldTitle>
      {label}
      {required && <S.RequiredAsterisk> *</S.RequiredAsterisk>}
    </S.FieldTitle>
    <S.StyledReactSelect
      border={border}
      options={options.map((state) => ({ value: state.name, label: state.name }))}
      value={options.find((state) => state.name === value) ? { value, label: value! } : null}
      onChange={(option: any) => onChange(option?.value ?? "")}
      placeholder={`Select ${label}`}
      isClearable
      classNamePrefix="react-select"
    />
  </S.FieldContainer>
);

export default StateSelectField; 